module.exports = __webpack_public_path__ + "static/translation-2f4150de65657f7713562e586f23b698.jpg";